import React, { useEffect, useRef, useState } from "react";
import "./index.scss";
import * as _ from "lodash";
import { useDispatch, useSelector } from "react-redux";
import { socketActions } from "../../../store/socket/slice";
import { useTranslation } from "react-i18next";
import { getImageUrl } from "../../../utils/image";

const ChatFooter = ({ config }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const fileInputRef = useRef(null);
  const socketManage = useSelector((state) => state.socketManage);
  const attachmentManage = useSelector((state) => state.attachmentManage);
  const textareaRef = useRef(null);
  const attachments = _.get(attachmentManage, "attachments", {});

  const isChat = _.get(config, "isChat", false);
  const isSound = _.get(socketManage, "isSound");
  const text = _.get(config, "text", "");
  const onChangeText = _.get(config, "onChangeText", () => {});
  const onSendMessage = _.get(config, "onSendMessage", () => {});
  const onChangeFile = _.get(config, "onChangeFile", () => {});
  const handleTogglePicker = _.get(config, "handleTogglePicker", () => {});
  const buttonEmojiRef = _.get(config, "buttonEmojiRef", null);
  const image = _.get(config, "image", null);
  const onRemoveImage = _.get(config, "onRemoveImage", () => {});
  const file = _.get(config, "file", null);
  const replyMessage = _.get(config, "replyMessage", null);
  const setReplyMessage = _.get(config, "setReplyMessage", () => {});
  const name = _.get(file, "name");
  const display = _.get(config, "display", 0);
  const replyName = _.get(config, "replyName", "");
  const isExpand = _.get(config, "isExpand", false);
  const showIconExpand = _.get(config, "showIconExpand", false);
  const setIsExpand = _.get(config, "setIsExpand", () => {});
  const setShowIconExpand = _.get(config, "setShowIconExpand", () => {});

  const fileTypeIcon = (name, type) => {
    const ext = name.split(".").pop()?.toLowerCase() || "";

    if (type.includes("pdf") || ext === "pdf") return "pdf";
    if (type.includes("word") || ["doc", "docx"].includes(ext)) return "word";
    if (type.includes("excel") || ["xls", "xlsx"].includes(ext)) return "excel";

    return "default";
  };

  const isImage = _.startsWith(_.get(file, "type", ""), "image");
  const fileType = file ? fileTypeIcon(file.name, file.type) : "default";
  const handleButtonClick = () => {
    fileInputRef.current?.click();
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      if (event.shiftKey) {
        return;
      }
      event.preventDefault();
      onSendMessage();
    }
  };

  useEffect(() => {
    const el = textareaRef.current;
    if (el) {
      requestAnimationFrame(() => {
        el.style.height = "auto";
        el.style.height = isExpand
          ? "353px"
          : Math.min(el.scrollHeight, 60) + "px";
      });
    }
  }, [text, display, isExpand]);

  return isChat ? (
    <div
      style={{ backgroundColor: "#fff" }}
      className="chat-content-footer border-top px-3 d-flex gap-2 justify-content-between align-items-center position-relative"
    >
      <div
        className="chat-input-action-box px-3"
        style={{
          display: _.get(replyMessage, "_id") ? "block" : "none",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
          }}
          className="chat-input-action-reply bg-gray-light gap-2 p-1 px-2 rounded-2"
        >
          <div
            style={{
              width: "90%",
            }}
          >
            <div className="one-line">
              <strong>
                {t("agent.chat.reply")}
                {replyName ? ` ${replyName}` : ""}:
              </strong>{" "}
              {_.get(replyMessage, "content", "")}
            </div>
            {(attachments[_.get(replyMessage, "_id", "")] || []).map(
              (attachment, index) => {
                const url = getImageUrl(_.get(attachment, "url", ""));
                const name = _.get(attachment, "name", "");
                const type = _.get(attachment, "type", "");
                const isImage = _.startsWith(type, "image");
                const iconType = fileTypeIcon(name, type);

                return (
                  <div key={index} className="chat-mess-attachment mt-2">
                    {isImage && (
                      <img
                        src={url}
                        alt={name}
                        className="chat-attachment-image rounded"
                        style={{
                          maxWidth: "70px",
                          maxHeight: "50px",
                        }}
                      />
                    )}
                    {!isImage && (
                      <div className="chat-mess-text d-flex gap-2 align-items-center">
                        {iconType === "pdf" && (
                          <img
                            src="/img/chat/icon/pdf.svg"
                            alt="pdf"
                            width={18}
                          />
                        )}
                        {iconType === "word" && (
                          <img
                            src="/img/chat/icon/word.svg"
                            alt="word"
                            width={18}
                          />
                        )}
                        {iconType === "excel" && (
                          <img
                            src="/img/chat/icon/excel.svg"
                            alt="excel"
                            width={18}
                          />
                        )}
                        {iconType === "default" && (
                          <svg
                            className="icon"
                            width="15"
                            height="18"
                            viewBox="0 0 15 18"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M12.7259 9.47925L7.5759 14.6376C6.90074 15.2376 6.02185 15.557 5.119 15.5304C4.21615 15.5038 3.35756 15.1333 2.71888 14.4946C2.08019 13.8559 1.70966 12.9973 1.68308 12.0945C1.6565 11.1916 1.97588 10.3127 2.5759 9.63758L9.24256 2.97091C9.64058 2.59283 10.1686 2.38202 10.7176 2.38202C11.2665 2.38202 11.7945 2.59283 12.1926 2.97091C12.5804 3.3639 12.7978 3.8938 12.7978 4.44591C12.7978 4.99802 12.5804 5.52792 12.1926 5.92091L6.44256 11.6626C6.38566 11.7239 6.31724 11.7733 6.24121 11.8082C6.16519 11.843 6.08304 11.8625 5.99947 11.8656C5.9159 11.8687 5.83253 11.8553 5.75414 11.8262C5.67574 11.7971 5.60385 11.7528 5.54256 11.6959C5.48128 11.639 5.43181 11.5706 5.39696 11.4946C5.36212 11.4185 5.3426 11.3364 5.3395 11.2528C5.33641 11.1692 5.3498 11.0859 5.37892 11.0075C5.40805 10.9291 5.45232 10.8572 5.50923 10.7959L9.78423 6.52925C9.94115 6.37233 10.0293 6.1595 10.0293 5.93758C10.0293 5.71566 9.94115 5.50283 9.78423 5.34591C9.62731 5.18899 9.41448 5.10084 9.19256 5.10084C8.97065 5.10084 8.75782 5.18899 8.6009 5.34591L4.3259 9.62925C4.11199 9.8415 3.9422 10.094 3.82634 10.3722C3.71048 10.6504 3.65083 10.9487 3.65083 11.2501C3.65083 11.5514 3.71048 11.8498 3.82634 12.128C3.9422 12.4062 4.11199 12.6587 4.3259 12.8709C4.76288 13.2872 5.34324 13.5193 5.94673 13.5193C6.55022 13.5193 7.13059 13.2872 7.56756 12.8709L13.3092 7.12091C13.9716 6.41004 14.3322 5.46981 14.3151 4.4983C14.298 3.52679 13.9044 2.59987 13.2173 1.9128C12.5303 1.22574 11.6033 0.832178 10.6318 0.815037C9.66034 0.797896 8.72011 1.15851 8.00923 1.82091L1.34256 8.48758C0.443564 9.48327 -0.0365782 10.7875 0.00217603 12.1284C0.0409303 13.4693 0.595592 14.7436 1.5506 15.6857C2.5056 16.6278 3.78729 17.1651 5.12863 17.1857C6.46997 17.2062 7.76751 16.7084 8.7509 15.7959L13.9092 10.6459C13.9869 10.5682 14.0486 10.476 14.0906 10.3745C14.1327 10.2729 14.1543 10.1641 14.1543 10.0542C14.1543 9.94436 14.1327 9.83556 14.0906 9.73404C14.0486 9.63252 13.9869 9.54028 13.9092 9.46258C13.8315 9.38488 13.7393 9.32325 13.6378 9.2812C13.5363 9.23915 13.4274 9.2175 13.3176 9.2175C13.2077 9.2175 13.0989 9.23915 12.9974 9.2812C12.8958 9.32325 12.8036 9.38488 12.7259 9.46258V9.47925Z"
                              fill="#211F26"
                            />
                          </svg>
                        )}
                        <a
                          target="_blank"
                          rel="noopener noreferrer"
                          href={url}
                          style={{
                            maxWidth: "160px",
                            color: "#212529",
                            direction: "rtl",
                            textAlign: "left",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                          className="ellipsis-start"
                        >
                          {name}
                        </a>
                      </div>
                    )}
                  </div>
                );
              }
            )}
          </div>
          <button
            onClick={() => setReplyMessage(null)}
            className="chat-input-action-reply-close"
            style={{
              background: "none",
              border: "none",
            }}
          >
            <img src="/img/chat/icon/x.svg" alt="" />
          </button>
        </div>
      </div>
      <div className="chat-input-box position-relative w-100">
        {isImage && image && (
          <div className="mb-2 position-relative d-inline-block">
            <img
              src={image}
              alt="Preview"
              style={{
                maxHeight: "70px",
                width: "100%",
                maxWidth: "100px",
                borderRadius: "8px",
              }}
            />
            <button
              onClick={() => onRemoveImage()}
              className="btn btn-sm btn-danger position-absolute top-0 end-0 m-1 rounded-circle"
              style={{
                width: "15px",
                height: "15px",
                padding: 0,
              }}
              title="Xoá ảnh"
            >
              ×
            </button>
          </div>
        )}
        {!isImage && image && (
          <div
            className="mb-2 position-relative"
            style={{
              display: "flex",
            }}
          >
            <div>
              {fileType === "pdf" && (
                <img src="/img/chat/icon/pdf.svg" alt="pdf" width={18} />
              )}
              {fileType === "word" && (
                <img src="/img/chat/icon/word.svg" alt="word" width={18} />
              )}
              {fileType === "excel" && (
                <img src="/img/chat/icon/excel.svg" alt="excel" width={18} />
              )}
              {fileType === "default" && (
                <svg
                  className="icon"
                  width="15"
                  height="18"
                  viewBox="0 0 15 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12.7259 9.47925L7.5759 14.6376C6.90074 15.2376 6.02185 15.557 5.119 15.5304C4.21615 15.5038 3.35756 15.1333 2.71888 14.4946C2.08019 13.8559 1.70966 12.9973 1.68308 12.0945C1.6565 11.1916 1.97588 10.3127 2.5759 9.63758L9.24256 2.97091C9.64058 2.59283 10.1686 2.38202 10.7176 2.38202C11.2665 2.38202 11.7945 2.59283 12.1926 2.97091C12.5804 3.3639 12.7978 3.8938 12.7978 4.44591C12.7978 4.99802 12.5804 5.52792 12.1926 5.92091L6.44256 11.6626C6.38566 11.7239 6.31724 11.7733 6.24121 11.8082C6.16519 11.843 6.08304 11.8625 5.99947 11.8656C5.9159 11.8687 5.83253 11.8553 5.75414 11.8262C5.67574 11.7971 5.60385 11.7528 5.54256 11.6959C5.48128 11.639 5.43181 11.5706 5.39696 11.4946C5.36212 11.4185 5.3426 11.3364 5.3395 11.2528C5.33641 11.1692 5.3498 11.0859 5.37892 11.0075C5.40805 10.9291 5.45232 10.8572 5.50923 10.7959L9.78423 6.52925C9.94115 6.37233 10.0293 6.1595 10.0293 5.93758C10.0293 5.71566 9.94115 5.50283 9.78423 5.34591C9.62731 5.18899 9.41448 5.10084 9.19256 5.10084C8.97065 5.10084 8.75782 5.18899 8.6009 5.34591L4.3259 9.62925C4.11199 9.8415 3.9422 10.094 3.82634 10.3722C3.71048 10.6504 3.65083 10.9487 3.65083 11.2501C3.65083 11.5514 3.71048 11.8498 3.82634 12.128C3.9422 12.4062 4.11199 12.6587 4.3259 12.8709C4.76288 13.2872 5.34324 13.5193 5.94673 13.5193C6.55022 13.5193 7.13059 13.2872 7.56756 12.8709L13.3092 7.12091C13.9716 6.41004 14.3322 5.46981 14.3151 4.4983C14.298 3.52679 13.9044 2.59987 13.2173 1.9128C12.5303 1.22574 11.6033 0.832178 10.6318 0.815037C9.66034 0.797896 8.72011 1.15851 8.00923 1.82091L1.34256 8.48758C0.443564 9.48327 -0.0365782 10.7875 0.00217603 12.1284C0.0409303 13.4693 0.595592 14.7436 1.5506 15.6857C2.5056 16.6278 3.78729 17.1651 5.12863 17.1857C6.46997 17.2062 7.76751 16.7084 8.7509 15.7959L13.9092 10.6459C13.9869 10.5682 14.0486 10.476 14.0906 10.3745C14.1327 10.2729 14.1543 10.1641 14.1543 10.0542C14.1543 9.94436 14.1327 9.83556 14.0906 9.73404C14.0486 9.63252 13.9869 9.54028 13.9092 9.46258C13.8315 9.38488 13.7393 9.32325 13.6378 9.2812C13.5363 9.23915 13.4274 9.2175 13.3176 9.2175C13.2077 9.2175 13.0989 9.23915 12.9974 9.2812C12.8958 9.32325 12.8036 9.38488 12.7259 9.46258V9.47925Z"
                    fill="#211F26"
                  />
                </svg>
              )}
            </div>
            <div
              style={{
                display: "flex",
              }}
            >
              <span
                style={{
                  maxWidth: "240px",
                  paddingLeft: "10px",
                  display: "inline-block",
                  direction: "rtl",
                  textAlign: "left",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {name}
              </span>
            </div>
            <div
              style={{
                display: "flex",
              }}
            >
              <button
                onClick={() => onRemoveImage()}
                className="btn btn-sm position-absolute top-0 end-0 m-1 rounded-circle"
                style={{
                  width: "15px",
                  height: "15px",
                  padding: 0,
                }}
                title="Xoá ảnh"
              >
                x
              </button>
            </div>
          </div>
        )}
        <div className="textarea-box py-3">
          <textarea
            ref={textareaRef}
            name="message"
            rows={1}
            value={text}
            onChange={(e) => {
              onChangeText(e.target.value);
              const el = e.target;
              el.style.height = "auto";
              el.style.height = isExpand
                ? "353px"
                : Math.min(el.scrollHeight, 60) + "px";
              if (text.split("\n").length > 2) {
                setShowIconExpand(true);
              } else {
                setShowIconExpand(false);
              }
            }}
            onKeyDown={handleKeyDown}
            className="form-control chat-input-mess p-0 border-0"
            placeholder={t("widget.write_message")}
            style={{
              overflowY: text.split("\n").length > 3 ? "scroll" : "hidden",
              maxHeight: "250px",
              lineHeight: "20px",
              resize: "none",
            }}
          />
          <button
            onClick={() => setIsExpand(!isExpand)}
            style={
              showIconExpand
                ? { background: "none", border: "none", display: "block" }
                : {}
            }
            className="expandTextarea"
          >
            <svg
              width="21"
              height="20"
              viewBox="0 0 21 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.83364 5.25458C9.83364 5.71481 10.2067 6.08791 10.667 6.08791L13.9584 6.08791L13.9584 9.37937C13.9584 9.8396 14.3315 10.2127 14.7918 10.2127C15.252 10.2127 15.6251 9.8396 15.6251 9.37937L15.6251 5.25458C15.6251 4.79434 15.252 4.42124 14.7918 4.42124L10.667 4.42124C10.2067 4.42124 9.83364 4.79434 9.83364 5.25458Z"
                fill="#677187"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.27338 9.83474C5.73361 9.83474 6.10671 10.2078 6.10671 10.6681L6.10671 13.9595H9.39817C9.8584 13.9595 10.2315 14.3326 10.2315 14.7929C10.2315 15.2531 9.8584 15.6262 9.39817 15.6262L5.27338 15.6262C4.81314 15.6262 4.44004 15.2531 4.44004 14.7929L4.44004 10.6681C4.44004 10.2078 4.81314 9.83474 5.27338 9.83474Z"
                fill="#677187"
              />
            </svg>
          </button>
        </div>
        <div className="d-flex gap-2 py-2 justify-content-between align-items-center">
          <div className="d-flex gap-2 align-items-center">
            <div className="dropdown">
              <button
                style={{ background: "none", border: "none" }}
                className="color-dark fw-semibold dropdown-toggle"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10 8.33398C9.67037 8.33398 9.34813 8.43173 9.07405 8.61487C8.79997 8.798 8.58635 9.0583 8.4602 9.36285C8.33406 9.66739 8.30105 10.0025 8.36536 10.3258C8.42967 10.6491 8.5884 10.9461 8.82149 11.1792C9.05458 11.4123 9.35155 11.571 9.67485 11.6353C9.99815 11.6996 10.3333 11.6666 10.6378 11.5405C10.9424 11.4143 11.2026 11.2007 11.3858 10.9266C11.5689 10.6525 11.6667 10.3303 11.6667 10.0007C11.6667 9.55862 11.4911 9.1347 11.1785 8.82214C10.866 8.50958 10.442 8.33398 10 8.33398ZM4.16667 8.33398C3.83703 8.33398 3.5148 8.43173 3.24072 8.61487C2.96664 8.798 2.75301 9.0583 2.62687 9.36285C2.50072 9.66739 2.46772 10.0025 2.53203 10.3258C2.59633 10.6491 2.75507 10.9461 2.98816 11.1792C3.22124 11.4123 3.51822 11.571 3.84152 11.6353C4.16482 11.6996 4.49993 11.6666 4.80447 11.5405C5.10902 11.4143 5.36931 11.2007 5.55245 10.9266C5.73559 10.6525 5.83333 10.3303 5.83333 10.0007C5.83333 9.55862 5.65774 9.1347 5.34518 8.82214C5.03262 8.50958 4.6087 8.33398 4.16667 8.33398ZM15.8333 8.33398C15.5037 8.33398 15.1815 8.43173 14.9074 8.61487C14.6333 8.798 14.4197 9.0583 14.2935 9.36285C14.1674 9.66739 14.1344 10.0025 14.1987 10.3258C14.263 10.6491 14.4217 10.9461 14.6548 11.1792C14.8879 11.4123 15.1849 11.571 15.5082 11.6353C15.8315 11.6996 16.1666 11.6666 16.4711 11.5405C16.7757 11.4143 17.036 11.2007 17.2191 10.9266C17.4023 10.6525 17.5 10.3303 17.5 10.0007C17.5 9.55862 17.3244 9.1347 17.0118 8.82214C16.6993 8.50958 16.2754 8.33398 15.8333 8.33398Z"
                    fill="#677187"
                  />
                </svg>
              </button>
              <ul className="dropdown-menu">
                <li>
                  <div className="dropdown-item py-2">
                    <label className="form-switch p-0 gap-3 d-flex align-items-center justify-content-between">
                      <span>Enable sound</span>
                      <input
                        className="form-check-input m-0"
                        type="checkbox"
                        checked={isSound}
                        onChange={(e) => {
                          dispatch(socketActions.setIsSound(e.target.checked));
                        }}
                      />
                    </label>
                  </div>
                </li>
              </ul>
            </div>
            <button
              style={{ background: "none", border: "none" }}
              onClick={() => {
                handleButtonClick();
              }}
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15.0667 10.3503L9.91672 15.5087C9.24156 16.1087 8.36267 16.4281 7.45982 16.4015C6.55697 16.3749 5.69839 16.0044 5.0597 15.3657C4.42101 14.727 4.05048 13.8684 4.0239 12.9656C3.99732 12.0627 4.3167 11.1838 4.91672 10.5087L11.5834 3.84201C11.9814 3.46392 12.5094 3.25311 13.0584 3.25311C13.6074 3.25311 14.1354 3.46392 14.5334 3.84201C14.9212 4.235 15.1386 4.7649 15.1386 5.31701C15.1386 5.86912 14.9212 6.39901 14.5334 6.79201L8.78338 12.5337C8.72648 12.595 8.65806 12.6444 8.58203 12.6793C8.50601 12.7141 8.42386 12.7336 8.34029 12.7367C8.25672 12.7398 8.17335 12.7264 8.09496 12.6973C8.01656 12.6682 7.94467 12.6239 7.88339 12.567C7.8221 12.5101 7.77263 12.4417 7.73779 12.3657C7.70294 12.2896 7.68342 12.2075 7.68032 12.1239C7.67723 12.0403 7.69062 11.957 7.71974 11.8786C7.74887 11.8002 7.79315 11.7283 7.85005 11.667L12.1251 7.40034C12.282 7.24342 12.3701 7.03059 12.3701 6.80867C12.3701 6.58675 12.282 6.37393 12.1251 6.21701C11.9681 6.06009 11.7553 5.97193 11.5334 5.97193C11.3115 5.97193 11.0986 6.06009 10.9417 6.21701L6.66672 10.5003C6.45281 10.7126 6.28302 10.9651 6.16716 11.2433C6.0513 11.5215 5.99165 11.8198 5.99165 12.1212C5.99165 12.4225 6.0513 12.7209 6.16716 12.9991C6.28302 13.2773 6.45281 13.5298 6.66672 13.742C7.1037 14.1582 7.68406 14.3904 8.28755 14.3904C8.89104 14.3904 9.47141 14.1582 9.90839 13.742L15.6501 7.99201C16.3125 7.28113 16.6731 6.3409 16.6559 5.36939C16.6388 4.39789 16.2452 3.47096 15.5582 2.7839C14.8711 2.09683 13.9442 1.70327 12.9727 1.68613C12.0012 1.66899 11.0609 2.02961 10.3501 2.69201L3.68339 9.35867C2.78438 10.3544 2.30424 11.6585 2.343 12.9995C2.38175 14.3404 2.93641 15.6147 3.89142 16.5568C4.84642 17.4989 6.12812 18.0362 7.46946 18.0567C8.8108 18.0773 10.1083 17.5795 11.0917 16.667L16.2501 11.517C16.3278 11.4393 16.3894 11.3471 16.4314 11.2455C16.4735 11.144 16.4951 11.0352 16.4951 10.9253C16.4951 10.8155 16.4735 10.7066 16.4314 10.6051C16.3894 10.5036 16.3278 10.4114 16.2501 10.3337C16.1724 10.256 16.0801 10.1943 15.9786 10.1523C15.8771 10.1102 15.7683 10.0886 15.6584 10.0886C15.5485 10.0886 15.4397 10.1102 15.3382 10.1523C15.2367 10.1943 15.1444 10.256 15.0667 10.3337V10.3503Z"
                  fill="#677187"
                />
              </svg>
            </button>
            <input
              type="file"
              ref={fileInputRef}
              onChange={onChangeFile}
              style={{ display: "none" }}
            />
            <button
              style={{ background: "none", border: "none" }}
              className=""
              ref={buttonEmojiRef}
              onClick={handleTogglePicker}
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7.01675 10.1743C7.09462 10.2516 7.18696 10.3127 7.2885 10.3542C7.39003 10.3956 7.49875 10.4166 7.60842 10.416C7.71809 10.4166 7.82681 10.3956 7.92834 10.3542C8.02987 10.3127 8.12222 10.2516 8.20009 10.1743L9.45009 8.92435C9.52819 8.84688 9.59019 8.75471 9.63249 8.65316C9.6748 8.55161 9.69658 8.44269 9.69658 8.33268C9.69658 8.22267 9.6748 8.11375 9.63249 8.0122C9.59019 7.91065 9.52819 7.81849 9.45009 7.74102L8.20009 6.49102C8.12239 6.41332 8.03014 6.35168 7.92863 6.30963C7.82711 6.26758 7.7183 6.24594 7.60842 6.24594C7.49854 6.24594 7.38973 6.26758 7.28821 6.30963C7.18669 6.35168 7.09445 6.41332 7.01675 6.49102C6.93905 6.56871 6.87742 6.66096 6.83537 6.76247C6.79332 6.86399 6.77167 6.9728 6.77167 7.08268C6.77167 7.19257 6.79332 7.30137 6.83537 7.40289C6.87742 7.50441 6.93905 7.59665 7.01675 7.67435L7.67509 8.33268L7.01675 8.99102C6.93864 9.06849 6.87665 9.16065 6.83434 9.2622C6.79204 9.36375 6.77025 9.47267 6.77025 9.58268C6.77025 9.69269 6.79204 9.80161 6.83434 9.90316C6.87665 10.0047 6.93864 10.0969 7.01675 10.1743ZM11.9668 11.841C11.4097 12.2902 10.7157 12.5351 10.0001 12.5351C9.28451 12.5351 8.59049 12.2902 8.03342 11.841C7.86324 11.6996 7.64384 11.6315 7.42348 11.6518C7.20313 11.6721 6.99987 11.7792 6.85842 11.9493C6.71697 12.1195 6.64892 12.3389 6.66923 12.5593C6.68955 12.7796 6.79657 12.9829 6.96675 13.1243C7.81787 13.8349 8.89139 14.224 10.0001 14.224C11.1088 14.224 12.1823 13.8349 13.0334 13.1243C13.2036 12.9829 13.3106 12.7796 13.3309 12.5593C13.3513 12.3389 13.2832 12.1195 13.1418 11.9493C13.0717 11.8651 12.9858 11.7954 12.8888 11.7444C12.7919 11.6933 12.6858 11.6619 12.5767 11.6518C12.3563 11.6315 12.1369 11.6996 11.9668 11.841ZM12.5001 7.49935C12.3353 7.49935 12.1742 7.54822 12.0371 7.63979C11.9001 7.73136 11.7933 7.86151 11.7302 8.01378C11.6671 8.16605 11.6506 8.33361 11.6828 8.49526C11.7149 8.65691 11.7943 8.80539 11.9108 8.92194C12.0274 9.03848 12.1759 9.11785 12.3375 9.15C12.4992 9.18216 12.6667 9.16566 12.819 9.10258C12.9713 9.03951 13.1014 8.9327 13.193 8.79566C13.2845 8.65862 13.3334 8.4975 13.3334 8.33268C13.3334 8.11167 13.2456 7.89971 13.0893 7.74343C12.9331 7.58715 12.7211 7.49935 12.5001 7.49935ZM10.0001 1.66602C8.35191 1.66602 6.74074 2.15476 5.37033 3.07044C3.99992 3.98611 2.93182 5.2876 2.30109 6.81032C1.67036 8.33304 1.50533 10.0086 1.82687 11.6251C2.14842 13.2416 2.94209 14.7265 4.10753 15.8919C5.27297 17.0573 6.75782 17.851 8.37433 18.1726C9.99084 18.4941 11.6664 18.3291 13.1891 17.6983C14.7118 17.0676 16.0133 15.9995 16.929 14.6291C17.8447 13.2587 18.3334 11.6475 18.3334 9.99935C18.3334 8.905 18.1179 7.82137 17.6991 6.81032C17.2803 5.79927 16.6665 4.88061 15.8926 4.10679C15.1188 3.33297 14.2002 2.71914 13.1891 2.30035C12.1781 1.88156 11.0944 1.66602 10.0001 1.66602ZM10.0001 16.666C8.68154 16.666 7.39261 16.275 6.29628 15.5425C5.19996 14.8099 4.34547 13.7687 3.84089 12.5506C3.3363 11.3324 3.20428 9.99195 3.46152 8.69875C3.71875 7.40554 4.35369 6.21765 5.28604 5.2853C6.21839 4.35295 7.40628 3.71802 8.69948 3.46078C9.99269 3.20355 11.3331 3.33557 12.5513 3.84015C13.7695 4.34474 14.8107 5.19922 15.5432 6.29555C16.2758 7.39188 16.6668 8.68081 16.6668 9.99935C16.6668 11.7675 15.9644 13.4632 14.7141 14.7134C13.4639 15.9636 11.7682 16.666 10.0001 16.666Z"
                  fill="#677187"
                />
              </svg>
            </button>
          </div>
          <div className="send-box">
            {!text.trim() && !file ? (
              <a
                href="https://izihelp.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img height={16} src="/img/logo-footer.svg" alt="" />
              </a>
            ) : (
              <button
                style={{ background: "none", border: "none" }}
                onClick={() => {
                  if (onSendMessage) {
                    onSendMessage();
                  }
                }}
              >
                <img
                  width="22px"
                  height="22px"
                  src="/img/chat/icon/send.svg"
                  alt=""
                />
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  ) : (
    <div className="chat-content-footer border-top px-3 d-flex gap-2 justify-content-between align-items-center position-relative">
      <div className="chat-input-box position-relative w-100">
        <div className="d-flex gap-2 py-2 justify-content-between align-items-center">
          <div className="d-flex gap-2 align-items-center">
            <div className="dropdown">
              <button
                style={{ background: "none", border: "none" }}
                className="color-dark fw-semibold dropdown-toggle"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10 8.33398C9.67037 8.33398 9.34813 8.43173 9.07405 8.61487C8.79997 8.798 8.58635 9.0583 8.4602 9.36285C8.33406 9.66739 8.30105 10.0025 8.36536 10.3258C8.42967 10.6491 8.5884 10.9461 8.82149 11.1792C9.05458 11.4123 9.35155 11.571 9.67485 11.6353C9.99815 11.6996 10.3333 11.6666 10.6378 11.5405C10.9424 11.4143 11.2026 11.2007 11.3858 10.9266C11.5689 10.6525 11.6667 10.3303 11.6667 10.0007C11.6667 9.55862 11.4911 9.1347 11.1785 8.82214C10.866 8.50958 10.442 8.33398 10 8.33398ZM4.16667 8.33398C3.83703 8.33398 3.5148 8.43173 3.24072 8.61487C2.96664 8.798 2.75301 9.0583 2.62687 9.36285C2.50072 9.66739 2.46772 10.0025 2.53203 10.3258C2.59633 10.6491 2.75507 10.9461 2.98816 11.1792C3.22124 11.4123 3.51822 11.571 3.84152 11.6353C4.16482 11.6996 4.49993 11.6666 4.80447 11.5405C5.10902 11.4143 5.36931 11.2007 5.55245 10.9266C5.73559 10.6525 5.83333 10.3303 5.83333 10.0007C5.83333 9.55862 5.65774 9.1347 5.34518 8.82214C5.03262 8.50958 4.6087 8.33398 4.16667 8.33398ZM15.8333 8.33398C15.5037 8.33398 15.1815 8.43173 14.9074 8.61487C14.6333 8.798 14.4197 9.0583 14.2935 9.36285C14.1674 9.66739 14.1344 10.0025 14.1987 10.3258C14.263 10.6491 14.4217 10.9461 14.6548 11.1792C14.8879 11.4123 15.1849 11.571 15.5082 11.6353C15.8315 11.6996 16.1666 11.6666 16.4711 11.5405C16.7757 11.4143 17.036 11.2007 17.2191 10.9266C17.4023 10.6525 17.5 10.3303 17.5 10.0007C17.5 9.55862 17.3244 9.1347 17.0118 8.82214C16.6993 8.50958 16.2754 8.33398 15.8333 8.33398Z"
                    fill="#677187"
                  />
                </svg>
              </button>
              <ul className="dropdown-menu">
                <li>
                  <div className="dropdown-item py-2">
                    <label className="form-switch p-0 gap-3 d-flex align-items-center justify-content-between">
                      <span>Enable sound</span>
                      <input
                        className="form-check-input m-0"
                        type="checkbox"
                        checked={isSound}
                        onChange={(e) => {
                          dispatch(socketActions.setIsSound(e.target.checked));
                        }}
                      />
                    </label>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div className="send-box">
            <a
              href="https://izihelp.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img height={16} src="/img/logo-footer.svg" alt="" />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChatFooter;
